import { JwtPayload, jwtDecode } from "jwt-decode";

interface DecodedToken extends JwtPayload {
  "https://auth0.carrot.tech/email": string;
  "https://auth0.carrot.tech/name": string;
}

export function getTokenData(): DecodedToken | undefined {
  const cookieToken = document.cookie.replace(
    /(?:(?:^|.*;\s*)token\s*=\s*([^;]*).*$)|^.*$/,
    "$1",
  );
  if (cookieToken) {
    return jwtDecode(cookieToken) as DecodedToken;
  }
  return undefined;
}
